import "@/App.css";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider, ROUTES } from "./i18n/LangContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Preloader, StarCursor } from "./components/Motion";
import { Seo } from "./components/Seo";
import Home from "./pages/Home";
import Work from "./pages/Work";
import Services from "./pages/Services";
import Studio from "./pages/Studio";
import Contact from "./pages/Contact";
import PricingSheet from "./pages/PricingSheet";
import { AuthProvider } from "./admin/auth";
import AdminLogin from "./admin/AdminLogin";
import AdminInbox from "./admin/AdminInbox";

const PAGES = { home: Home, work: Work, services: Services, studio: Studio, contact: Contact, sheet: PricingSheet };

const SiteLayout = () => (
  <LangProvider>
    <div className="grain min-h-screen bg-ink text-ivory">
      <Seo />
      <Preloader />
      <StarCursor />
      <Header />
      <main><Outlet /></main>
      <Footer />
    </div>
  </LangProvider>
);

const AdminLayout = () => (
  <AuthProvider>
    <Outlet />
    <Toaster theme="dark" position="bottom-right" />
  </AuthProvider>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AdminLayout />}>
          <Route path="/admin" element={<AdminInbox />} />
          <Route path="/admin/login" element={<AdminLogin />} />
        </Route>
        <Route element={<SiteLayout />}>
          {Object.entries(PAGES).flatMap(([key, Page]) =>
            ["en", "es"].map((l) => <Route key={`${key}-${l}`} path={ROUTES[key][l]} element={<Page />} />)
          )}
          <Route path="/es/*" element={<Navigate to="/es" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
